var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "h-100 flex justify-content-center align-items-center",
            },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: { loading: true, color: _vm.$constants.LOADING_COLOR },
              }),
            ],
            1
          )
        : [
            !_vm.dialogs
              ? [_c("h5", [_vm._v("Диалогов не найдено")])]
              : [
                  _c("div", { staticClass: "row m-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3 card p-0 dialogs_block" },
                      [
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(_vm.dialogs, function (dialog) {
                            return _c(
                              "div",
                              {
                                key: dialog.id,
                                class: {
                                  dialog_select: true,
                                  active:
                                    _vm.selectedDialog &&
                                    _vm.selectedDialog.id === dialog.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectDialog(dialog.id)
                                  },
                                },
                              },
                              [
                                _vm._l(dialog.users, function (u) {
                                  return _c("p", [_vm._v(_vm._s(u.user.name))])
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-muted text-right chat_date",
                                  },
                                  [
                                    _vm._v(
                                      "(U:" +
                                        _vm._s(dialog.user_id) +
                                        " " +
                                        _vm._s(dialog.id) +
                                        ")\n                " +
                                        _vm._s(
                                          _vm.printDate(
                                            dialog.created_at,
                                            "DD.MM HH:mm"
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-9 card p-0" }, [
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _vm.allowToClose
                            ? _c("LoadingButton", {
                                attrs: {
                                  title: "Решено",
                                  type: "button",
                                  loading: _vm.sendLoading,
                                  color: _vm.$constants.SUCCESS_COLOR,
                                  onClick: () => _vm.acceptDialog(true),
                                  className:
                                    "btn btn-outline-success close_btn",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.selectedDialog
                            ? [_c("h5", [_vm._v("Выберите диалог")])]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "messages_list" },
                                  _vm._l(
                                    _vm.selectedDialog.messages,
                                    function (message) {
                                      return _c(
                                        "div",
                                        {
                                          key: message.id,
                                          class: {
                                            single_message: true,
                                            my_message:
                                              +message.user_id ===
                                              _vm.$currentUID,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "author" }, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  (_vm.users[message.user_id] &&
                                                    _vm.users[message.user_id]
                                                      .name) ||
                                                    "не указано"
                                                ) +
                                                "\n                    "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-muted message_date",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.printDate(
                                                      message.created_at,
                                                      "DD.MM HH:mm"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "triangle",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "message" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(message.message) +
                                                  "\n                    "
                                              ),
                                              message.acknowledge_by
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "read_marker",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.printDate(
                                                              message
                                                                .acknowledge_by[0]
                                                                .date,
                                                              "DD.MM HH:mm",
                                                              false,
                                                              0
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "icon-fa icon-fa-check",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.selectedDialog.is_active
                                  ? _c(
                                      "form",
                                      {
                                        on: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            return _vm.sendMessage.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.message,
                                                  expression: "message",
                                                },
                                              ],
                                              staticClass: "form-control br-0",
                                              attrs: {
                                                type: "text",
                                                disabled: _vm.sendLoading,
                                                required: "",
                                                placeholder: "Сообщение",
                                              },
                                              domProps: { value: _vm.message },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.message =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-append",
                                              },
                                              [
                                                _c("LoadingButton", {
                                                  attrs: {
                                                    title: "Отправить",
                                                    type: "submit",
                                                    loading: _vm.sendLoading,
                                                    color:
                                                      _vm.$constants
                                                        .LOADING_COLOR,
                                                    onClick: () => {},
                                                    className:
                                                      "btn btn-outline-info br-0",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                    ]),
                  ]),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }